import * as Constants from "../constants";

/* todo: jain - duplicate  w/ browse.js */
export const GET_PUBLISHED_FQ = () => {
  let fq:string = "&fq=published:true";  //default is only show published

  /* todo: jain - publishedOnly comes from "${grailsApplication.config.publishedOnly}"; */
  /* let publishedOnly:string = PUBLISHED_ONLY.toLowerCase();
  if (publishedOnly.charAt(0) == 'f') {// if user passes in f, then remove the fq
    fq = "";
  }*/

  return fq;
}

export const BatesQuery = (collectionCode: string[], rows: number, dir: string, bates: number ): string => {
  let query: string = "q=*:*";
  query += "&fq=(collectioncode:\"" + collectionCode.join("\" OR collectioncode:\"") + "\")";
  query += GET_PUBLISHED_FQ()
  query += "&fl=id,au,ti,bn,dd,dt,availability,pg,attach,access,artifact,industry,collection";
  query += "&wt=json";
  query += "&indent=true";
  query += "&rows=" + rows;

  switch (dir) {
    case Constants.PREV:
      query += "&fq=bn:[* TO \"" + bates + "\"}";
      query += "&sort=bn_sort desc";
      break;

    case  Constants.NEXT:
      query += "&fq=bn:{\"" + bates + "\" TO *]";
      query += "&sort=bn_sort asc";
      break;

    default:
  }

  return query;
}
